import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles((theme) => ({
  dialogEditCSVData: {
    '& .MuiPaper-rounded': {
      borderRadius: '16px',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'center',
    padding: '30px 20px 50px 20px',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '24px',
    color: themesConfig.default.colors.primary,
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(0),
    color: themesConfig.default.colors.primary,
  },

  dialogActions: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 27,
  },
  saveButton: {
    width: 'max-content',
    height: 36,
    borderRadius: 4,
    color: themesConfig.default.colors['primary-lighter'],
    backgroundColor: themesConfig.default.colors.primary,
  },

  fieldLabel: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 8,
    color: themesConfig.default.colors.primary,
  },
}))

export const useStylesTextField = makeStyles(() => ({
  root: {
    '& .MuiInput-underline:after': {
      borderBottomColor: themesConfig.default.colors['grey-400'],
    },

    '& .MuiFormHelperText-root': {
      fontSize: 14,
      lineHeight: '20px',
      marginTop: 8,
      marginLeft: 0,
    },

    '& .MuiSelect-select': {
      backgroundColor: 'transparent',
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: themesConfig.default.colors['grey-400'],
      },
      '&:hover fieldset': {
        borderColor: themesConfig.default.colors['grey-400'],
      },
      '&.Mui-focused fieldset': {
        borderWidth: '1px',
        borderColor: themesConfig.default.colors['grey-400'],
      },
      '&.Mui-error fieldset': {
        borderColor: themesConfig.default.colors['grey-400'],
      },
    },
  },
  error: {
    '& .MuiFormHelperText-root.Mui-error': {
      color: themesConfig.default.colors['red-500'],
    },
  },

  warning: {
    '& .MuiFormHelperText-root.Mui-error': {
      color: themesConfig.default.colors['orange-600'],
    },
  },

  select: {
    marginTop: 5,
    maxHeight: 300,
    '& .MuiListItem-gutters': {
      fontSize: 14,
      paddingLeft: 24,
      color: themesConfig.default.colors.primary,
      lineHeight: '20px',
    },
  },
}))
